import { Component, Input, OnInit } from '@angular/core';
import { ImageViewerComponent, ImageViewerData } from '../../components/image-viewer/image-viewer.component';
import { LegacyDialogsService } from '../../services/legacy-dialogs.service';

const TextureViewerImageFit = {
  None: 'none',
  Contain: 'contain',
  Cover: 'cover',
  Fill: 'fill',
  ScaleDown: 'scale-down',

  Inherit: 'inherit',
  Inital: 'inital',
  Revert: 'revert',
  Unset: 'unset',
} as const;

export type TextureViewerImageFit = typeof TextureViewerImageFit[keyof typeof TextureViewerImageFit];

@Component({
  selector: 'csl-texture-viewer',
  templateUrl: './texture-viewer.component.html',
  styleUrls: ['./texture-viewer.component.scss'],
})
export class TextureViewerComponent implements OnInit {
  @Input() textureLink = '';
  @Input() cropTextureLink = '';
  @Input() color = '';
  @Input() imageFit: TextureViewerImageFit = TextureViewerImageFit.Fill;

  constructor(private dialogs: LegacyDialogsService) {}

  ngOnInit(): void {}

  openTextureViewerDialog(link: string): void {
    this.dialogs.open(ImageViewerComponent, {
      panelClass: 'image-viewer-dialog',
      data: {
        textureLink: link,
      } as ImageViewerData,
    });
  }
}
